// Export the Component Definition for use in Contentful Studio
export {IconContentfulComponentDefinition} from './iconContentfulDefinition';
export {default} from './Icon';
